export default {
  checkData(list1) {
    console.log(list1)
    let result = true
    for (let i = 0; i < list1.length; i++) {
      const elem = list1[i]
      const count = elem.batchs && elem.batchs.length
        ? elem.batchs.map(i => i.goodsCount).reduce((total, item) => {
          return total + item
        })
        : 0
      console.log(count)
      if (count > elem.productCount) {
        result = false
        break
      }
    }
    return result
    // let l1 = {}
    // let l2 = {}
    // list1.forEach(i => {
    //   l1[i.productId] = i.productCount
    // })
    // list2.forEach(i => {
    //   let id = i.productId
    //   if (l2[id]) {
    //     l2[id] += i.goodsCount
    //   } else {
    //     l2[id] = i.goodsCount
    //   }
    // })
    // let keys = Object.keys(l1)
    // let result = true
    // for (let i = 0; i < keys.length; i++) {
    //   if (l2[keys[i]] > l1[keys[i]]) {
    //     result = false
    //     break
    //   }
    // }
    // return result
  },
  getIds(inspect) {
    const result = []
    inspect.inspectReportDetails.forEach(i => {
      (i.batchs || []).forEach(s => {
        result.push(s.batchId)
      })
    })
    return result
  }
}
